import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ProviderPreferenceEditorData } from "../../state/ProviderPreferences/EditorData";


const updateProviderPreferencesEditorData: Reducer<ProviderPreferenceEditorData> = 
  (state: ProviderPreferenceEditorData = new ProviderPreferenceEditorData(), action: Action<ActionType, ProviderPreferenceEditorData>) => {
  switch (action.type) {
    case ActionType.PROVIDER_PREFERENCES_EDITOR_DATA_RESET:
      return new ProviderPreferenceEditorData();
    case ActionType.PROVIDER_PREFERENCES_EDITOR_DATA_FETCHED:
      return { ...state, preferenceData: action.data };
    case ActionType.PROVIDER_PREFERENCES_EDITOR_DATA_COPIED:
      return { ...state, preferenceData: { ...action.data} };
    case ActionType.PROVIDER_PREFERENCES_EDITOR_DATA_UPDATED:
      return { ...state, preferenceData: { ...state.preferenceData, ...action.data } };
    case ActionType.PROVIDER_PREFERENCES_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.PROVIDER_PREFERENCES_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    default:
      return state;
  }
};

export default updateProviderPreferencesEditorData;